import {useCognitoConfig} from "@/hooks";
import AwsCognito from '@/services/AwsCognito'
import { useAuthStore } from "@/store"

let cognitoInstance: AwsCognito | null = null;

export const getCognitoInstance = async (): Promise<AwsCognito> => {
    if (!cognitoInstance) {
        const cognitoConfig = useCognitoConfig();
        const authStore = useAuthStore();
        authStore.config = await cognitoConfig.getCognitoConfig();
        cognitoInstance = new AwsCognito(authStore.config);
    }
    return cognitoInstance;
};
